import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './household-composition.reducer';

export const HouseholdCompositionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const householdCompositionEntity = useAppSelector(state => state.householdComposition.entity);
  const loading = useAppSelector(state => state.householdComposition.loading);
  const updating = useAppSelector(state => state.householdComposition.updating);
  const updateSuccess = useAppSelector(state => state.householdComposition.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/household-composition${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllHouseholds !== undefined && typeof values.totalAllHouseholds !== 'number') {
      values.totalAllHouseholds = Number(values.totalAllHouseholds);
    }
    if (values.onePersonHousehold !== undefined && typeof values.onePersonHousehold !== 'number') {
      values.onePersonHousehold = Number(values.onePersonHousehold);
    }
    if (values.singleFamilyHousehold !== undefined && typeof values.singleFamilyHousehold !== 'number') {
      values.singleFamilyHousehold = Number(values.singleFamilyHousehold);
    }
    if (values.otherHouseholdTypes !== undefined && typeof values.otherHouseholdTypes !== 'number') {
      values.otherHouseholdTypes = Number(values.otherHouseholdTypes);
    }

    const entity = {
      ...householdCompositionEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...householdCompositionEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.householdComposition.home.createOrEditLabel" data-cy="HouseholdCompositionCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.householdComposition.home.createOrEditLabel">
              Create or edit a HouseholdComposition
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="household-composition-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.householdComposition.geographicLevel')}
                id="household-composition-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.householdComposition.date')}
                id="household-composition-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.householdComposition.geography')}
                id="household-composition-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.householdComposition.geographyCode')}
                id="household-composition-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.householdComposition.totalAllHouseholds')}
                id="household-composition-totalAllHouseholds"
                name="totalAllHouseholds"
                data-cy="totalAllHouseholds"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdComposition.onePersonHousehold')}
                id="household-composition-onePersonHousehold"
                name="onePersonHousehold"
                data-cy="onePersonHousehold"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdComposition.singleFamilyHousehold')}
                id="household-composition-singleFamilyHousehold"
                name="singleFamilyHousehold"
                data-cy="singleFamilyHousehold"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.householdComposition.otherHouseholdTypes')}
                id="household-composition-otherHouseholdTypes"
                name="otherHouseholdTypes"
                data-cy="otherHouseholdTypes"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/household-composition" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HouseholdCompositionUpdate;
